
import Footer from '../components/Footer';
import Sample01 from '../images/sample-01.png';
import Sample02 from '../images/sample-02.png';

import './HomePage.css';

const HomePage = () => {    

    return (
        <div className='home-page'>
            <div className='home-page-content'>
            <div className='home-background-overlay'></div>
                <div className='home-page-title'>
                    FactSense:  Your Personal Fact-Checking Assistant
                </div>
                <div className='home-page-intro'>
                    FactSense is a useful tool designed to help users 
                    verify the credibility of claims with ease and confidence.
                     Whether you're reading breaking news, social posts, 
                     or encountering suspicious images, 
                     FactSense empowers you with multiple layers of verification:
                </div>
                     <ol className='home-page-intro-list'>
                        <li>Claim Review Search:  FactSense searches trusted 
                            claim review databases to check if a statement has 
                            already been evaluated by reputable fact-checking 
                            organizations.
                        </li>
                        <li>Image Comparison: Upload an image, 
                            and FactSense will compare it against verified 
                            images found in existing claim reviews to detect 
                            signs of manipulation or misrepresentation.
                        </li>
                        <li>Credible Source Cross-Check: 
                            The app uses machine learning to search authoritative 
                            sources like Wikipedia and other credible databases, 
                            helping you validate claims based on existing, 
                            trustworthy information.
                        </li>
                        <li>
                            AI-Powered Reasoning: 
                            Still uncertain?&nbsp;&nbsp;FactSense can query advanced language 
                            models to analyze the statement and give you a direct, 
                            reasoned response on its likely accuracy.
                        </li>
                    </ol>
                <div className='home-section'>
                    <img src={Sample01} className="screenshot" alt="sample" />

                    <div className='home-section-description'>
                        <p>
                            The APISource is the method you choose to test the claim against.&nbsp;&nbsp;
                            There are three options - 
                            Claim Reviews, Creditable Internet Source, and
                            Machine Learning Model
                        </p>
                    </div>
                </div>
                <div className='home-section'>
                    <img src={Sample02} className="screenshot" alt="sample" />

                    <div className='home-section-description'>
                        <p>
                            This is a check of claim reviews, for the claim "Vaccines causes autism".&nbsp;&nbsp;   
                            FactCheck.org has already checked this claim and
                            found it to be false.  
                        </p>
                    </div>
                </div>

                <div className='home-citation'>
                    <p>
                        The machine learning technology use the following datasets and models:
                    </p>
                    <br/>
                    <div className='citation-block'>
                    <code>
                        @inproceedings&#123;10.1145/3459637.3481961,<br />
                        &nbsp;&nbsp;author = &#123;Trokhymovych, Mykola and Saez-Trumper, Diego&#125;,<br />
                        &nbsp;&nbsp;title = &#123;WikiCheck: An End-to-End Open Source Automatic Fact-Checking API Based on Wikipedia&#125;,<br />
                        &nbsp;&nbsp;year = &#123;2021&#125;,<br />
                        &nbsp;&nbsp;isbn = &#123;9781450384469&#125;,<br />
                        &nbsp;&nbsp;publisher = &#123;Association for Computing Machinery&#125;,<br />
                        &nbsp;&nbsp;address = &#123;New York, NY, USA&#125;,<br />
                        &nbsp;&nbsp;url = &#123;<a href="https://doi.org/10.1145/3459637.3481961" target="_blank" rel="noopener noreferrer">https://doi.org/10.1145/3459637.3481961</a>&#125;,<br />
                        &nbsp;&nbsp;doi = &#123;10.1145/3459637.3481961&#125;,<br />
                        &nbsp;&nbsp;booktitle = &#123;Proceedings of the 30th ACM International Conference on Information &amp; Knowledge Management&#125;,<br />
                        &nbsp;&nbsp;pages = &#123;4155–4164&#125;,<br />
                        &nbsp;&nbsp;numpages = &#123;10&#125;,<br />
                        &nbsp;&nbsp;keywords = &#123;applied research, nlp, nli, wikipedia, fact-checking&#125;,<br />
                        &nbsp;&nbsp;location = &#123;Virtual Event, Queensland, Australia&#125;,<br />
                        &nbsp;&nbsp;series = &#123;CIKM '21&#125;<br />
                        &#125;
                    </code>
                    </div>

                    <div className="citation-block">
                        <code>
                            @misc&#123;zhang2024tinyllama,<br />
                            &nbsp;&nbsp;title = &#123;TinyLlama: An Open-Source Small Language Model&#125;,<br />
                            &nbsp;&nbsp;author = &#123;Peiyuan Zhang and Guangtao Zeng and Tianduo Wang and Wei Lu&#125;,<br />
                            &nbsp;&nbsp;year = &#123;2024&#125;,<br />
                            &nbsp;&nbsp;eprint = &#123;2401.02385&#125;,<br />
                            &nbsp;&nbsp;archivePrefix = &#123;arXiv&#125;,<br />
                            &nbsp;&nbsp;primaryClass = &#123;cs.CL&#125;<br />
                            &#125;
                        </code>
                    </div>
                </div>
            </div>
            
            <Footer />
        </div>
    )
}

export default HomePage;